import { render, staticRenderFns } from "./MetricClassTooltip.vue?vue&type=template&id=1f10dc16&scoped=true"
import script from "./MetricClassTooltip.vue?vue&type=script&lang=js"
export * from "./MetricClassTooltip.vue?vue&type=script&lang=js"
import style0 from "./MetricClassTooltip.vue?vue&type=style&index=0&id=1f10dc16&prod&scoped=true&lang=sass"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1f10dc16",
  null
  
)

export default component.exports